<template>
  <div
    class="acLottiePreloader"
    :class="{
      'acLottiePreloader--fullpage': fullpage,
      'acLottiePreloader--overlay': overlay
    }"
    data-test="ac-lottie-preloader"
    role="status"
    aria-label="Загрузка"
  >
    <Vue3Lottie
      :animation-data="preloaderHeart"
      :height="normalizedSize"
      :width="normalizedSize"
      :loop="true"
      :auto-play="true"
      aria-hidden="true"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Vue3Lottie } from 'vue3-lottie'
import preloaderHeart from '@web/platform.v3/assets/lottie/preloader-heart.json'

interface Props {
  size?: number | string
  fullpage?: boolean
  overlay?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  size: 100,
  fullpage: false,
  overlay: false
})

const normalizedSize = computed(() =>
  typeof props.size === 'number' ? `${props.size}px` : props.size
)
</script>

<style lang="scss" scoped>
.acLottiePreloader {
  display: flex;
  align-items: center;
  justify-content: center;

  &--fullpage {
    width: 100%;
    height: 100vh;
  }

  &--overlay {
    position: fixed;
    inset: 0;
    z-index: 9999;
    background: rgba(255, 255, 255, 0.6);
    backdrop-filter: blur(2px);
  }
}
</style>
